/**
 * Every sprite the game uses, by atlas frame name (= PNG file name in assets/).
 * Keep this in sync when adding art; `npm run build` fails on typos elsewhere.
 */
import type { TileKind } from '../core/types';

export const DOG_IDS = ['honey', 'pretzel', 'mochi', 'biscuit', 'muffin', 'pepper', 'coco', 'kiko'] as const;
export type DogId = (typeof DOG_IDS)[number];
export type DogPose = 'rescued' | 'happy' | 'sleeping';

export const tileFrame = (kind: TileKind) => `tile_${kind}` as const;
export const dogFrame = (dog: DogId, pose: DogPose) => `dog_${dog}_${pose}` as const;

export const FRAMES = {
  stripeH: 'special_stripe_h',
  stripeV: 'special_stripe_v',
  bombRing: 'special_bomb_ring',
  colorstar: 'special_colorstar',
  mud2: 'obstacle_mud_2',
  mud1: 'obstacle_mud_1',
  pawStain: 'obstacle_paw_stain',
  cellCream: 'board_cell_cream',
  cellLatte: 'board_cell_latte',
  frameCorner: 'board_frame_corner',
  frameEdge: 'board_frame_edge',
  hammer: 'booster_hammer',
  spoon: 'booster_spoon',
  moves5: 'booster_moves5',
  coin: 'ui_coin',
  bandanaPaw: 'cosmetic_bandana_paw',
} as const;

export const BACKGROUNDS = {
  gameplayCafe: 'bg_gameplay_cafe',
  gameplayParis: 'bg_gameplay_paris',
  cafeRoomEmpty: 'cafe_room_empty',
} as const;
